export default {
  computed: {
    dataLineCollection() {
      if (Object.keys(this.data.graph_data).length) {
        return {
          labels: this.getLabels(),
          datasets: this.getDataSets()
        };
      }

      return {};
    }
  },
  methods: {
    getAges(data) {
      return data.map(item => item[1]);
    },
    getDataSets() {
      let entries = Object.entries(this.data.graph_data);
      let series = [];

      entries.forEach(item => {
        let ageKey = `${this.data.graph_data[item[0]].start}-${this.data.graph_data[item[0]].end}`;
        series.push({
          label: ageKey === "0-0" ? this.$t('feed.audit.involvement.body.unknown') : ageKey,
          borderColor: this.age[item[0]],
          borderWidth: 1,
          pointRadius: 3,
          pointBackgroundColor: this.age[item[0]].main,
          pointBorderColor: this.age[item[0]].main,
          backgroundColor: this.age[item[0]].main,
          fontColor: this.age[item[0]].font,
          labelAlign: this.age[item[0]].align,
          data: this.getAges(this.data.graph_data[item[0]].graph)
        });
      });
      return series;
    },
    getLabels() {
      const key = Object.entries(this.data.graph_data)[0][0];
      let dataArr = this.data.graph_data[key].graph;

      return dataArr.map(item => {
        let dateSeparator = "-";

        if (item[0].includes(dateSeparator)) {
          let dateArr = item[0].split('-');
          let month = parseInt(dateArr[1]) - 1;

          return [item[0].slice(-2), this.month[month]];
        }

        return item[0];
      });
    }
  },
  data() {
    return {
      month: this.$t('feed.audit.involvement.body.month'),
      endTime: '23:59:59',
      lineOptions: {
        layout: {
          padding: {
            left: 0,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)"
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            boxWidth: 7,
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: false
          },
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
